module.exports = __webpack_public_path__ + "img/fauteuil-23.1af9e315.jpg";